import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Login from "./pages/Login/Login";
import Question1 from "./pages/Question1/Question1";
import AdminLogin from "./pages/Admin/Login/AdminLogin";
import ShowLeads from "./pages/Admin/ShowLeads/ShowLeads";
import { useEffect } from "react";
import LoginClone from "./pages/Login/LoginClone.jsx";
import ShowSponsorship from "./pages/Admin/ShowSponsorship/ShowSponsorship.jsx";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // In App.js
  useEffect(() => {
    const formSubmitted = localStorage.getItem("formSubmitted") === "true";

    if (formSubmitted && location.pathname !== "/") {
      navigate("/", { replace: true });
    } else if (!formSubmitted && location.pathname === "/") {
      navigate("/", { replace: true });
    }
  }, [navigate, location]);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />{" "}
        <Route path="/login1" element={<LoginClone />} />
        {/* Clone of the login page */}
        <Route path="/preference" element={<Question1 />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/adminleads" element={<ShowLeads />} />
        <Route path="/adminSponsorship" element={<ShowSponsorship />} />
      </Routes>
    </div>
  );
}

export default App;
